import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { fetchAuthSession } from "@/api-queries/auth";

export const Route = createFileRoute("/dashboard/therapist")({
  beforeLoad: async ({ location }) => {
    const session = await fetchAuthSession();
    if (!session?.user) throw redirect({ to: "/login" });
    if (session.user.role !== "therapist") throw redirect({ to: "/dashboard" });

    // First-login onboarding gate: redirect to the wizard until completed.
    const isOnboardingRoute = location.pathname.startsWith("/dashboard/therapist/onboarding");
    if (!isOnboardingRoute) {
      const meRes = await fetch("/api/therapist/me");
      // Fail open: on a transient profile-fetch error we let the therapist into
      // the dashboard rather than locking them out; the gate re-checks next nav.
      if (meRes.ok) {
        const me = await meRes.json();
        // Migrated therapists must confirm payout method + accept the platform terms
        // before entering the dashboard, even if they somehow finished onboarding.
        const needsBillingTerms = me.isMigrated && !me.termsAcceptedAt;
        // Contract gate: while an admin keeps an active ugovor_terapeut, every
        // therapist has to accept it (server enforces the same on /complete).
        const needsContract = Boolean(me.contract?.required) && !me.contract?.acceptedAt;
        if (!me.onboardingCompletedAt || needsBillingTerms || needsContract) {
          throw redirect({ to: "/dashboard/therapist/onboarding" });
        }
      }
    }

    return { session };
  },
  component: TherapistLayout,
});

function TherapistLayout() {
  return (
    <div className="mx-auto w-full max-w-6xl">
      <Outlet />
    </div>
  );
}
